var _path, _circle, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeverage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3547 73.1644C50.5055 73.2814 50.7097 73.3023 50.8811 73.2183C51.0525 73.1343 51.1611 72.9601 51.1611 72.7693V65.7157C55.6534 66.9285 60.4627 64.123 61.4025 59.3153C61.8572 56.9892 63.4185 55.0313 65.5851 54.0704C70.6302 51.8329 72.1048 45.3725 68.5301 41.1675C66.995 39.3617 66.4378 36.9203 67.0373 34.6273C68.4335 29.2877 64.3019 24.1069 58.7856 24.2799C56.4166 24.3542 54.1605 23.2677 52.7415 21.3693C49.4374 16.9485 42.8109 16.9485 39.5068 21.3693C38.0878 23.2677 35.8317 24.3542 33.4627 24.2799C27.9464 24.1069 23.8148 29.2877 25.211 34.6273C25.8106 36.9203 25.2533 39.3617 23.7182 41.1675C20.1436 45.3725 21.6181 51.8329 26.6632 54.0704C28.8298 55.0313 30.3911 56.9892 30.8458 59.3153C31.7462 63.9212 36.198 66.6895 40.5201 65.8474V72.7693C40.5201 72.9601 40.6287 73.1343 40.8001 73.2183C40.9714 73.3023 41.1757 73.2814 41.3265 73.1644L45.8406 69.6637L50.3547 73.1644ZM41.5201 71.7488V65.586C41.9419 65.4468 42.3597 65.2713 42.77 65.0576C44.8721 63.9628 47.3762 63.9628 49.4783 65.0576C49.8316 65.2416 50.1905 65.3973 50.5527 65.5259H50.1611V71.7488L46.147 68.6358C45.9667 68.496 45.7145 68.496 45.5342 68.6358L41.5201 71.7488Z",
    stroke: "#302F3A",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.1236,
    cy: 42.8419,
    r: 11.9767,
    fill: "url(#paint0_linear_79_1857)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3417 21.6686C49.2375 17.5154 43.012 17.5154 39.9079 21.6686C38.3913 23.6978 35.9798 24.8591 33.4477 24.7797C28.2652 24.6171 24.3837 29.4844 25.6954 34.5008C26.3362 36.9517 25.7406 39.5612 24.0998 41.4913C20.7415 45.4418 22.1268 51.5112 26.8666 53.6134C29.1824 54.6404 30.8512 56.7331 31.3372 59.2193C32.3319 64.308 37.9409 67.0092 42.5396 64.6141C44.7865 63.444 47.4631 63.444 49.7099 64.6141C54.3087 67.0092 59.9177 64.308 60.9124 59.2193C61.3984 56.7331 63.0672 54.6404 65.383 53.6134C70.1228 51.5112 71.5081 45.4418 68.1498 41.4913C66.509 39.5612 65.9134 36.9517 66.5542 34.5008C67.8659 29.4844 63.9844 24.6171 58.8019 24.7797C56.2698 24.8591 53.8583 23.6978 52.3417 21.6686ZM46.1246 55.3184C53.0153 55.3184 58.6013 49.7324 58.6013 42.8417C58.6013 35.9511 53.0153 30.3651 46.1246 30.3651C39.2339 30.3651 33.6479 35.9511 33.6479 42.8417C33.6479 49.7324 39.2339 55.3184 46.1246 55.3184Z",
    fill: "url(#paint1_linear_79_1857)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1242 37.1704L47.791 40.5476L51.5179 41.0891L48.8211 43.7179L49.4577 47.4297L46.1242 45.6772L42.7908 47.4297L43.4274 43.7179L40.7306 41.0891L44.4575 40.5476L46.1242 37.1704Z",
    stroke: "#AAECD8",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1857",
    x1: 46.1236,
    y1: 31.6129,
    x2: 46.1236,
    y2: 55.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_1857",
    x1: 22.2497,
    y1: 18.5537,
    x2: 77.8936,
    y2: 52.5939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeverage);
export default __webpack_public_path__ + "static/media/Leverage.f178dbddfa502e3cd3145e3fb19d3609.svg";
export { ForwardRef as ReactComponent };